import type { ComputedRef } from 'vue';
import { reactive } from 'vue';

export function useWizardNavigation({
    hasPrevPage,
    hasNextPage,
}: {
    hasPrevPage?: ComputedRef<boolean>;
    hasNextPage?: ComputedRef<boolean>;
} = {}) {
    const navigation = {
        backwardNavigationEnabled: true,
        forwardNavigationEnabled: true,
        hasPrevPage: hasPrevPage ?? false,
        hasNextPage: hasNextPage ?? false,
        cancelEnabled: true,
        finishUrl: '',
        cancelUrl: '',
        enableBackwardNavigation(enabled?: boolean) {
            this.backwardNavigationEnabled = enabled ?? true;
        },
        enableForwardNavigation(enabled?: boolean) {
            this.forwardNavigationEnabled = enabled ?? true;
        },
        enableCancel(enabled?: boolean) {
            this.cancelEnabled = enabled ?? true;
        },
        firstPage() {
            this.hasPrevPage = false;
            this.hasNextPage = true;
        },
        middlePage() {
            this.hasPrevPage = true;
            this.hasNextPage = true;
        },
        lastPage() {
            this.hasPrevPage = true;
            this.hasNextPage = false;
        },
    };

    return reactive(navigation);
}

export type WizardNavigation = ReturnType<typeof useWizardNavigation>;
